import { createFileRoute } from '@tanstack/react-router'
import { LogoutScreen } from '../features/logout/LogoutScreen'

/** E8 — Logout confirmation route. Также является POST_LOGOUT_REDIRECT_URI для Keycloak. */
export const Route = createFileRoute('/logout')({
  component: LogoutScreen,
})
